import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const Clubs = withDefaultIconProps(
  {
    height: 30,
    width: 30,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 31 31">
      <Path
        d="M23.13 13.77C24.8 13.77 26.16 12.41 26.16 10.74C26.16 9.07 24.8 7.71 23.13 7.71C21.46 7.71 20.1 9.07 20.1 10.74C20.1 12.41 21.46 13.77 23.13 13.77ZM23.13 9.24C23.96 9.24 24.64 9.91 24.64 10.74C24.64 11.57 23.96 12.25 23.13 12.25C22.3 12.25 21.63 11.57 21.63 10.74C21.63 9.91 22.3 9.24 23.13 9.24Z"
        fill={color}
      />
      <Path
        d="M7.88 13.77C9.55 13.77 10.91 12.41 10.91 10.74C10.91 9.07 9.55 7.71 7.88 7.71C6.21 7.71 4.85 9.07 4.85 10.74C4.85 12.41 6.21 13.77 7.88 13.77ZM7.88 9.24C8.71 9.24 9.38 9.91 9.38 10.74C9.38 11.57 8.71 12.25 7.88 12.25C7.05 12.25 6.38 11.57 6.38 10.74C6.38 9.91 7.05 9.24 7.88 9.24Z"
        fill={color}
      />
      <Path
        d="M15.38 12.72C17.24 12.72 18.76 11.2 18.76 9.33C18.76 7.46 17.24 5.94 15.38 5.94C13.51 5.94 11.99 7.46 11.99 9.33C11.99 11.2 13.51 12.72 15.38 12.72ZM15.38 7.47C16.4 7.47 17.24 8.3 17.24 9.33C17.24 10.35 16.4 11.19 15.38 11.19C14.35 11.19 13.51 10.35 13.51 9.33C13.51 8.3 14.35 7.47 15.38 7.47Z"
        fill={color}
      />
      <Path
        d="M23.13 14.1C21.94 14.1 20.8 14.47 19.85 15.16C18.65 13.98 17.06 13.34 15.38 13.34C13.74 13.34 12.2 13.94 11.01 15.05C10.09 14.44 9 14.1 7.88 14.1C4.77 14.1 2.24 16.63 2.24 19.75V23.83C2.24 24.25 2.58 24.6 3 24.6H28.01C28.43 24.6 28.78 24.25 28.78 23.83V19.75C28.78 16.63 26.24 14.1 23.13 14.1ZM15.38 14.86C18.07 14.86 20.26 17.05 20.26 19.75V23.07H10.49V19.75C10.49 17.05 12.68 14.86 15.38 14.86ZM3.76 19.75C3.76 17.48 5.61 15.63 7.88 15.63C8.64 15.63 9.37 15.84 10.01 16.23C9.33 17.26 8.96 18.48 8.96 19.75V23.07H3.76V19.75ZM27.25 23.07H21.79V19.75C21.79 18.53 21.45 17.36 20.81 16.35C21.49 15.88 22.3 15.63 23.13 15.63C25.4 15.63 27.25 17.48 27.25 19.75V23.07Z"
        fill={color}
      />
    </Svg>
  ),
);
